var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"miss-word-text"},_vm._l((_vm.work.metadata.variants),function(variant,key){return _c('span',{key:key,class:`${variant.type === 'answer' ? 'answer' : ''}`,domProps:{"innerHTML":_vm._s(variant.value)}})}),0),_c('span',{staticClass:"badge badge-danger"},[_vm._v(_vm._s(_vm.check ? "Правильно" : "Неправильно"))])])
}
var staticRenderFns = []

export { render, staticRenderFns }